import Styled from 'styled-components';
import styled from "styled-components";

export const OptionsButtonContainer = Styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.davysGrey};
  color: ${(props) => props.theme.colors.davysGrey};
  background: transparent;
  cursor: pointer;
  position: relative;
`;

export const OptionsButtonOptionWrapper = styled.div`
    top: 35px;
    right: 0px;
    margin-top: 4px;
    position: absolute;
    display: ${(props) => (props.visible === "true" ? "flex" : "none")};
    width: 170px;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.silverGrayTwo};
    background: ${(props) => props.theme.colors.primaryWhite};
    z-index: 1000;
`;

export const ItemOptionWrapper = styled.div`
    display: flex;
    width: 100%;
    padding: 0 16px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    height: 30px;
    color: ${(props) => props.theme.colors.greyThirteen};
    ${props => props.theme.fonts.variant.bold()}
    font-size: 10px;
    font-style: normal;
    line-height: normal;
    cursor: pointer;
    &:not(:last-child) {
        border-bottom: 1px solid ${(props) => props.theme.colors.silverGrayTwo};
    }
    &:hover {
        opacity: 0.8;
    }
`;
